export const onEnterKeyEvent = (callback) => (event) => {
  if (event.key === 'Enter') {
    callback(event)
  }
}
